import { Paper } from "@mui/material";
import { Collections, ConfirmationNumber, Savings, Storage } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { useAccount } from "wagmi";

import { ChainLinkV2SupportedChains } from "@framework/types";
import { NodeEnv } from "@dzambalaorg/constants";
import { List } from "@dzambalaorg/ui-kit";

const data = [
  { text: "pages.raffle.contracts.title", link: "/raffle/contracts", icon: <Collections /> },
  { text: "pages.raffle.rounds.title", link: "/raffle/rounds", icon: <Savings /> },
  { text: "pages.raffle.tickets.title", link: "/raffle/ticket/contracts", icon: <ConfirmationNumber /> },
  { text: "pages.raffle.tokens.title", link: "/raffle/ticket/tokens", icon: <Storage /> },
];

export const RaffleSection = () => {
  const { chainId = 0 } = useAccount();

  if (process.env.NODE_ENV === NodeEnv.production && !ChainLinkV2SupportedChains[chainId]) {
    return null;
  }

  return (
    <Paper sx={{ mb: 2 }}>
      <List
        component="nav"
        subheader={
          <List.Subheader>
            <FormattedMessage id="pages.dashboard.mechanics.raffle" />
          </List.Subheader>
        }
      >
        {data.map(({ text, icon, link }) => (
          <List.ItemButton<typeof RouterLink> key={text} component={RouterLink} to={link}>
            <List.ItemIcon>{icon}</List.ItemIcon>
            <List.ItemText>
              <FormattedMessage id={text} />
            </List.ItemText>
          </List.ItemButton>
        ))}
      </List>
    </Paper>
  );
};
